var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('upload',{ref:"upload",attrs:{"fields":_vm.fields,"action":"","hasTable":"","title":_vm.$t('collection_request.upload.title')},on:{"submit":function($event){_vm.submit($event)},"upload":function($event){_vm.uploadFile($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }